import axios from 'axios';
import apiUrl from '../../api.config';

const SCHOOL_API_URL = `${apiUrl}school`;

// Add headers configuration
const getAuthHeaders = () => ({
    headers: {
        'x-access-token': localStorage.getItem('accessToken')
    }
});

export const SchoolApiService = {
    // 創建新學校
    createSchool: async (schoolData) => {
        try {
            const response = await axios.post(`${SCHOOL_API_URL}/create`, schoolData, getAuthHeaders());
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // 獲取所有學校
    getAllSchools: async () => {
        try {
            const response = await axios.get(`${SCHOOL_API_URL}/findAll`, getAuthHeaders());
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // 更新學校資訊
    updateSchool: async (id, schoolData) => {
        try {
            const response = await axios.put(`${SCHOOL_API_URL}/update/${id}`, schoolData, getAuthHeaders());
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // 刪除學校
    deleteSchool: async (id) => {
        try {
            const response = await axios.delete(`${SCHOOL_API_URL}/delete/${id}`, getAuthHeaders());
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    }
};

export default SchoolApiService; 